/*
    start - The model to begin with.
    path - period delimited string of attributes to walk returning the final attribute. It must ALWAYS begin with 'instance'.

    NOTE: To simplify syntax a path cannot traverse a collection but can terminate at one.
*/
const pathWalkerStep = (start, path = []) => {
    if (path.length === 0)
        return start;

    if (start instanceof Backbone.Collection)
        throw new Error("PathWalker cannot traverse a collection");

    const key = path.shift();
    return pathWalkerStep(start.get(key), path);
};

const pathWalker = (root, path = "") => {
    const pathArray = path.split(".");
    if (pathArray.shift() !== "instance")
        throw new Error("First entry in path should be \"instance\"");

    return pathWalkerStep(root, pathArray);
};

export default pathWalker;



// WEBPACK FOOTER //
// ./app/jsmodel/pathWalker.js